import React from 'react';
import PropTypes from 'prop-types';

const CheckCircleIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      fill={color}
    />
    <path
      d="M11.1998 5.6001L6.42679 10.4001L4.7998 8.76391"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CheckCircleIcon.propTypes = {
  color: PropTypes.string,
};

export default CheckCircleIcon;
